// Route guard component for routes that require authentication.
//
// Status-driven rather than boolean-driven (Pass 2.4): the
// AuthContext now has a "loading" state during initial token
// validation, and we MUST render a splash during loading rather
// than redirecting to /login (which would defeat the purpose of
// the three-state refactor — a stale routing decision against
// the wrong state IS the reload bug).

import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

import { useAuth } from "../state/AuthContext";
import { SplashScreen } from "./SplashScreen";

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <SplashScreen />;
  }
  if (status === "unauthenticated") {
    // Preserve the intended destination so we can route back
    // there after login. Stored in location.state.from.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
